export const MOBILE_TEXT_ENTRY_PROPS = Object.freeze({
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  writingsuggestions: "false",
});
